import { Component, HostBinding, Input, inject } from '@angular/core';

import {OutlookIndicatorComponent} from '../outlook-indicator/outlook-indicator.component';
import {OutlookIndicator} from '../../../../models/outlook-indicator';
import FinancialHealthService from '../../../../services/financial-health.service';
import {OutlookInfo} from '../../../../services/api/fit-api/models/indicators/outlook-info';
import {OUTLOOKS} from '../../../../models/outlook.config';

@Component({
    selector: 'app-outlook-icon-counts',
    imports: [OutlookIndicatorComponent],
    templateUrl: './outlook-icon-counts.component.html',
    styleUrls: ['./outlook-icon-counts.component.scss']
})
export class OutlookIconCountsComponent {
	private financialHealthService = inject(FinancialHealthService);

	@HostBinding('class')
	@Input() size: 'small' | 'medium' | 'large' = 'large';
	@Input() displayAllOutlooks?: boolean;
	// This is an array of OutlookInfo or OutlookIndicator objects (one per indicator)
	@Input()
	set outlookIndicators(value: Array<OutlookIndicator | OutlookInfo> | undefined) {
		this.outlookIndicatorsSummed = this.financialHealthService.getOutlookCounts(value);

		if (this.displayAllOutlooks) {
			this.outlookIndicatorsSummed = OUTLOOKS.map(outlook => {
				const match = this.outlookIndicatorsSummed?.find((outlookIndicator: OutlookIndicator) =>
					outlookIndicator.outlook === outlook.outlook)
				if (!match) {
					return new OutlookIndicator(outlook.outlook, null, 0);
				} else {
					return match;
				}
			})

		}
	}

	outlookIndicatorsSummed?: Array<OutlookIndicator>;
}
